import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dropdown-info',
  templateUrl: './dropdown-info.component.html',
  styleUrls: ['./dropdown-info.component.scss']
})
export class DropdownInfoComponent implements OnInit {

  expanded = false;
  _title: any;

  @Input()
  get title() {
    return this._title;
  };
  set title(title: any) {
 

    this._title = title;
  }

  _paragraphs: any;

  @Input()
  get paragraphs() {
    return this._paragraphs;
  };
  set paragraphs(paragraphs: any) {


    this._paragraphs = paragraphs;
  }
  constructor() { }

  ngOnInit(): void {



  }

  reset(): void {
    this.expanded = false;
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }

}
